import React, { useEffect, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import UserRoleTable from '../../../components/tables/UserRoleTable/UserRoleTable';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const UserRoles = () => {
    const navigate = useNavigate();
    const { user, hasRole } = useAuth();
    
    // Check if user has marketing manager role
    const isMarketingManager = hasRole('mr-manager');

    const handleAddUser = () => {
        navigate('/user-roles/add-new');
    };

    return (
        <Container fluid>
            <div className='user-roles-page'>
                <div className="d-flex justify-content-between align-items-center mt-5 mb-5">
                    <h3>User Roles</h3>
                    {/* Conditionally render the Add New User button */}
                    {!isMarketingManager && (
                        <Button onClick={handleAddUser} variant="primary">
                            Add New User
                        </Button>
                    )}
                </div>
                <UserRoleTable isMarketingManager={isMarketingManager} />
            </div>
        </Container>
    );
};

export default UserRoles;
